export default function InstagramIcon({ socialIconClass }) {
  return (
    <svg className={socialIconClass} viewBox='0 0 57.19 57.19'>
      <g id='Instagram'>
        <path
          fill='#fff'
          d='M28.64,22.06h-.09c-3.57,0-6.54,2.96-6.54,6.54s2.96,6.62,6.54,6.62h.09c3.57,0,6.54-2.96,6.54-6.62s-2.96-6.54-6.54-6.54Z'
        />
        <path
          fill='#fff'
          d='M36.92,13.52H20.27c-3.75,0-6.8,3.05-6.8,6.8v16.56c0,3.75,3.05,6.8,6.8,6.8h16.65c3.75,0,6.8-3.05,6.8-6.8V20.32c0-3.75-3.05-6.8-6.8-6.8Zm-8.28,25.01h-.09c-5.4,0-9.85-4.45-9.85-9.94s4.45-9.94,9.85-9.94h.09c5.4,0,9.94,4.53,9.94,9.94s-4.53,9.94-9.94,9.94Zm9.76-17.61c-1.22,0-2.09-.96-2.09-2.09s.87-2.09,2.09-2.09c1.13,0,2.09,.96,2.09,2.09s-.96,2.09-2.09,2.09Z'
        />
        <path
          fill='#fff'
          d='M28.6,0C12.8,0,0,12.8,0,28.6s12.8,28.6,28.6,28.6,28.6-12.8,28.6-28.6S44.39,0,28.6,0Zm18.26,36.96c0,5.4-4.45,9.85-9.85,9.85H20.19c-5.4,0-9.85-4.45-9.85-9.85V20.23c0-5.4,4.45-9.85,9.85-9.85h16.82c5.4,0,9.85,4.45,9.85,9.85v16.73Z'
        />
      </g>
    </svg>
  );
}
